export const getRebookingInfoUrl = (developmentSlug: string) => {
    const weeksOffDevelopmentSlugs: string[] = [
        'vita-student-manchester-circle-square',
        'coventry-cannon-park',
        'crosshall-street',
        'newcastle-leazes-park',
        'madrid-oria',
        'vita-student-cardiff',
        'house-of-social-first-street',
        'birmingham-gough-street',
        'edinburgh-new-waverley',
    ];
    const isWeeksOffDevelopment = weeksOffDevelopmentSlugs.includes(developmentSlug);

    const standardUrl = 'https://www.vitastudent.com/en/rebookers-cashback/';
    const weeksOffUrl = 'https://www.vitastudent.com/en/rebookers-discount/';

    return isWeeksOffDevelopment ? weeksOffUrl : standardUrl;
};
